import React from "react";
import Header from "../Appraisal/AppraisalList/component/Header/Header";
import MyPafsList from "./MyPafsList";
import "../Appraisal/AppraisalProgress.css";

const MyPafs = () => {
  return (
    <>
      <Header title="My PAFs" />
      <MyPafsList />
    </>
  );
};

export default MyPafs;
